module.exports = __webpack_public_path__ + "static/media/slide3.60c64b4b.png";